import React, { SyntheticEvent } from 'react';
import { Row, Cell } from 'react-table';

import { Checkbox } from '@trqk/components';

import { SendColumn } from '../../../../../types';

interface IncludeChannelCellProps {
    cell: Cell<TrqkGapChannel, GapChannelIncludeCellValue>;
    column: SendColumn<TrqkGapChannel>;
    row: Row<TrqkGapChannel>;
}

/**
 * Renders a checkbox that allows the user to select a channel in order to include it in the Gap
 * Analysis report.
 * @param props - {@link IncludeChannelCellProps}
 * @returns JSX
 */
export const IncludeChannelCell = ({
    cell,
    column,
    row,
}: IncludeChannelCellProps): JSX.Element => {
    const { send } = column;
    // `hasIncludedAudios` is also available on the cell value and was previously used for disabling
    // the checkbox when there are no included audios for the channel
    const {
        value: { channelId, checked },
    } = cell;

    return (
        <div className="pt-1 pl-1">
            <Checkbox
                checked={checked}
                color="primary"
                inputId={`row-selection-${row.id}`}
                onChange={(e: SyntheticEvent) => {
                    const target = e.target as HTMLInputElement;

                    send({
                        type: 'TOGGLE_GAP_CHANNEL_CHECKED',
                        value: {
                            channelId,
                            checked: target.checked,
                        },
                    });
                }}
                size="large"
            />
        </div>
    );
};
